// extracted by mini-css-extract-plugin
export default {"meals":"AvailableMeals_meals__4Drky","meals-appear":"AvailableMeals_meals-appear__1p7IY"};